// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__320O4","radioRow":"SimpleQuestionBuilderModal_radioRow__2z3gU"};